/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Svd_ModulesInputs */

const en_svd_modules = /** @type {(inputs: Svd_ModulesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} capability modules`)
};

const ar_svd_modules = /** @type {(inputs: Svd_ModulesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} وحدة قدرات`)
};

const bn_svd_modules = /** @type {(inputs: Svd_ModulesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}টি ক্যাপাবিলিটি মডিউল`)
};

const de_svd_modules = /** @type {(inputs: Svd_ModulesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Fähigkeitsmodule`)
};

const es_svd_modules = /** @type {(inputs: Svd_ModulesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} módulos de capacidad`)
};

const fr_svd_modules = /** @type {(inputs: Svd_ModulesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} modules de capacités`)
};

const pt_svd_modules = /** @type {(inputs: Svd_ModulesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} módulos de capacidade`)
};

const zh_svd_modules = /** @type {(inputs: Svd_ModulesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个功能模块`)
};

const tr_svd_modules = /** @type {(inputs: Svd_ModulesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} yetenek modülü`)
};

const ru_svd_modules = /** @type {(inputs: Svd_ModulesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} модулей возможностей`)
};

const pl_svd_modules = /** @type {(inputs: Svd_ModulesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} modułów możliwości`)
};

/**
* | output |
* | --- |
* | "{count} capability modules" |
*
* @param {Svd_ModulesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svd_modules = /** @type {((inputs: Svd_ModulesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svd_ModulesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svd_modules(inputs)
	if (locale === "bn") return bn_svd_modules(inputs)
	if (locale === "de") return de_svd_modules(inputs)
	if (locale === "es") return es_svd_modules(inputs)
	if (locale === "fr") return fr_svd_modules(inputs)
	if (locale === "pt") return pt_svd_modules(inputs)
	if (locale === "zh") return zh_svd_modules(inputs)
	if (locale === "tr") return tr_svd_modules(inputs)
	if (locale === "ru") return ru_svd_modules(inputs)
	if (locale === "pl") return pl_svd_modules(inputs)
	return en_svd_modules(inputs)
});